import {
  ExtendedTypography,
  GridEmptyState,
} from '@issuemanager/apps/client/components';
import { useAtlasSemanticThemeTokens } from '@issuemanager/apps/client/theme';
import { Link as MUILink, Stack } from '@mui/material';
import { Trans, useTranslation } from 'react-i18next';

type SLAsEmptyStateProps = {
  onAddSLAClick: () => void;
};

export function SLAsEmptyState(props: SLAsEmptyStateProps) {
  const { onAddSLAClick } = props;
  const { t } = useTranslation(['common', 'settings']);
  const semantic = useAtlasSemanticThemeTokens();

  return (
    <GridEmptyState>
      <Stack spacing={1.5} alignItems='center'>
        <ExtendedTypography fontWeight='medium'>
          {t('common:table.empty')}
        </ExtendedTypography>
        <ExtendedTypography
          variant='body2'
          color={semantic.color.text.muted.value}
        >
          <Trans
            i18nKey='settings:slaConfiguration.table.notFoundMessage'
            t={t}
            components={{
              addBtn: (
                <MUILink
                  component='button'
                  onClick={onAddSLAClick}
                  data-testid='add-sla-btn'
                  sx={{ pointerEvents: 'auto', verticalAlign: 'bottom' }}
                />
              ),
            }}
          />
        </ExtendedTypography>
      </Stack>
    </GridEmptyState>
  );
}
